import options from './chart-humidity.component';

export default {
    selector: 'dtChartHumidity',
    options
};
